import instance from "config/interceptor";

export const mutateEmergencyGenerateGeo = async (params: any) => {
  return await instance.put(`Delivery/Update/DownloadEmergencyFile`, params, {
    responseType: 'blob',
  });
};